import { useTypedSelector } from "@/redux/helpers/hooks.ts";
import * as S from "./styles.ts";
import { IStoreSlice } from "@/redux/slices/store/types.ts";
import { Tag } from "@template/icons";
import useBreakpoint from "@/lib/helpers/useBreakpoint.ts";

const Price = ({
                 price,
               }: {
  price: IStoreSlice["tlds"]["prices"]["prices"][0]["cost"]["1-4"];
}) => {
  const { check: isMd } = useBreakpoint("sm");

  const currency = useTypedSelector(
    (state) => state.store.site_version.currency,
  );
  const currencySymbol = currency === "USD" ? "$" : "£";

  const Visual = () => {
    switch (true) {
      case price.net === 0:
        return "FREE";
      case !!price.promo_net:
        return (
          <>
            <S.Promo>
              {isMd && <Tag />}
              {currencySymbol}
              {price.promo_net / 100}
            </S.Promo>
            <S.Strike>
              {currencySymbol}
              {price.net / 100}
            </S.Strike>
          </>
        );
      default:
        return `${currencySymbol}${price.net / 100}`;
    }
  };

  return (
    <S.Price>
      <Visual />
    </S.Price>
  );
};

const Result = ({
                  tld,
                }: {
  tld: IStoreSlice["tlds"]["prices"]["prices"][0];
}) => {
  const { check: isMd } = useBreakpoint("sm");

  if (!isMd) {
    return (
      <S.Result>
        <td>
          <Price price={tld.cost["1-4"]} />
        </td>
        <td>
          <p>.{tld.name}</p>
          <Price price={tld.cost["5-25"]} />
        </td>
        <td>
          <Price price={tld.cost["25+"]} />
        </td>
      </S.Result>
    );
  }

  return (
    <S.Result>
      <td>.{tld.name}</td>
      <td>
        <Price price={tld.cost["1-4"]} />
      </td>
      <td>
        <Price price={tld.cost["5-25"]} />
      </td>
      <td>
        <Price price={tld.cost["25+"]} />
      </td>
    </S.Result>
  );
};
export default Result;
